
import React from 'react';
import { useToast } from './use-toast';
import { Card } from './card';
import { Button } from './button';
import { X } from 'lucide-react';

export const Toaster = () => {
  const { toasts, dismiss } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2">
      {toasts.map((toast) => (
        <Card key={toast.id} className="p-4 shadow-lg max-w-sm">
          <div className="flex items-center justify-between">
            <div>
              {toast.title && (
                <div className="font-semibold">{toast.title}</div>
              )}
              {toast.description && (
                <div className="text-sm text-muted-foreground">
                  {toast.description}
                </div>
              )}
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => dismiss(toast.id)}
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        </Card>
      ))}
    </div>
  );
};
